import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Ring AIR product GIDs only (engraved + not-engraved, plus the US-store AIR
 * SKU on ROW/US/CA). Excludes travel charger, sizing kit, wrap, PRO, RARE.
 * Keep in sync with the engraved / not-engraved entries in
 * `RingAndRelatedProductsIdMap`.
 */
export const RingAirProductIdMap: Record<ShopifyStore, readonly string[]> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: [
          'gid://shopify/Product/7181298532422',
          'gid://shopify/Product/7129411813446',
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/7948546998514',
          'gid://shopify/Product/7918333264114',
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/7156336754748',
          'gid://shopify/Product/7129411813446',
          'gid://shopify/Product/7129625821244',
        ],
        [ShopifyStore.US]: [
          'gid://shopify/Product/6854366888032',
          'gid://shopify/Product/6853766807648',
        ],
        [ShopifyStore.EU]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        [ShopifyStore.GB]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/6854366888032',
          'gid://shopify/Product/6853766807648',
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        [ShopifyStore.MX]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        [ShopifyStore.ZA]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
        // JP aliases the EU Shopify backend (StoreAliasGroups.EU_UK_AU).
        [ShopifyStore.JP]: [
          'gid://shopify/Product/10950659113278',
          'gid://shopify/Product/10950629359934',
        ],
      }
    : {
        // Staging routes every store to uhtesting: cloned IN Ring AIR products.
        [ShopifyStore.IN]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.US]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.EU]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.GB]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.MX]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.ZA]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
        [ShopifyStore.JP]: [
          'gid://shopify/Product/15790525677641',
          'gid://shopify/Product/15790525546569',
        ],
      };
